export default "__VITE_ASSET__Cnex20uH__"